import { ProfileType, printDate } from "@rooted/shared";
import { Badge, Table, Tabs } from "antd";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useEmptyApplications } from "./useApplications";
import { useCount } from "../../../services/higher-order-searches";
import firebase from "firebase/app";
import { PageHeader } from "../../../components/PageHeader";

export const EmptyApplications: React.FC = () => {
  const [type, setType] = useState<ProfileType>("grower");
  const [data, dataLoading, dataError] = useEmptyApplications(type);

  return (
    <>
      <PageHeader title="Stage 1: Empty" breadcrumb />
      <Tabs
        defaultActiveKey="grower"
        //@ts-expect-error Cannot easily coerce string to ProfileType
        onChange={setType}
      >
        <Tabs.TabPane
          tab={
            <>
              Growers&nbsp;
              <Badge count={useCount(useEmptyApplications("grower"))} />
            </>
          }
          key="grower"
        />
        <Tabs.TabPane
          tab={
            <>
              Wholesale Buyers&nbsp;
              <Badge count={useCount(useEmptyApplications("wholesale-buyer"))} />
            </>
          }
          key="wholesale-buyer"
        />
        <Tabs.TabPane
          tab={
            <>
              Coops&nbsp;
              <Badge count={useCount(useEmptyApplications("coop"))} />
            </>
          }
          key="coop"
        />
      </Tabs>
      <Table columns={tableColumns} dataSource={data} pagination={false} />
    </>
  );
};

const tableColumns = [
  {
    title: "Owner ID",
    dataIndex: ["ownerId"],
    key: "owner",
    render: (text: string) => <b>{text}</b>,
    sorter: (a: any, b: any): any => b.ownerId.localeCompare(a.ownerId.toLowerCase()),
    sortDirections: ["ascend", "descend"] as any, // SortOrder from antd
  },
  {
    title: "Created",
    dataIndex: ["_created"],
    key: "created",
    width: 150,
    render: (created: firebase.firestore.Timestamp) => <>{printDate(created)}</>,
    sorter: (a: any, b: any): any => a._created - b._created,
    sortDirections: ["ascend", "descend"] as any, // SortOrder from antd
    defaultSortOrder: "descend" as any, // SortOrder from antd
  },
  {
    title: "Status",
    dataIndex: ["status"],
    key: "name",
    className: "text-center",
    width: 110,
    render: (status: string) => <span style={{ textTransform: "capitalize" }}>{status}</span>,
  },
  {
    title: "",
    key: "action",
    width: 56,
    className: "col-action pad-left-0",
    // TODO this seems overridden by row-click below
    render: (x: any, record: any) => (
      <Link to={`/admin/applications/item/${record._id}`}>More...</Link>
    ),
  },
];
